import React from "react";
import styled from "styled-components";
import { InView } from "react-intersection-observer";
import "./animations.css";
import MainSection from "../components/MainSection";
import { LocationIcon } from "../components/icon";

const Container = styled.div`
  padding: 5rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  @media (min-width: 768px) and (max-width: 819px) {
    padding: 2.5rem 3rem;
  }
  
  @media (max-width: 767px) {
    padding: 2.5rem 1rem;
  }
`;

const MapWrapper = styled.div`
  width: 100%;
  padding: 16px 64px 56px 64px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2rem;
  width: 100%;

  @media (min-width: 768px) and (max-width: 819px) {
    padding: 2.5rem 3rem;
  }

  @media screen and (max-width: 767px) {
    padding: 2.5rem 1rem;
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  position: relative;
  height: 490px;
  border-radius: 38px;
  overflow: hidden;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 38px;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

const PageTitle = styled.h2`
  font-weight: 700;
  font-size: 40px;
  color: #514e4e;

  @media screen and (max-width: 780px) {
    font-size: 32px;
  }
`;

const GoogleMapHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;

const OfficeTour = () => {
  return (
    <>
      <MainSection
        bannerTxt="OFFICE TOUR"
        nonNavigablePaths={["office-tour"]}
      />
      <Container>
        <PageTitle>Office Tour</PageTitle>
        <InView triggerOnce threshold={0.1}>
          {({ inView, ref }) => (
            <VideoContainer ref={ref} className={inView ? "fade-in-up" : ""}>
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/4fB1YRNw8VE"
                title="Office Tour"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </VideoContainer>
          )}
        </InView>
      </Container>
      <MapWrapper>
        <GoogleMapHeader>
          <LocationIcon w={16} h={16} fill="#006CFF" />
          <a
            href="https://maps.app.goo.gl/1vUE6ZCU6ZdUcft16"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#006CFF" }}
          >
            See on Google Maps
          </a>
        </GoogleMapHeader>
        <InView triggerOnce threshold={0.1}>
          {({ inView, ref }) => (
            <MapContainer ref={ref} className={inView ? "fade-in-up" : ""}>
              <iframe
                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=SafeNet+Education+Consultancy+%26+Services+Yangon&zoom=17"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SafeNet Education Office Location"
              ></iframe>
            </MapContainer>
          )}
        </InView>
      </MapWrapper>
    </>
  );
};

export default OfficeTour;
